import { createContext, Dispatch } from 'react'
import { ActionType, StateType } from 'typesafe-actions'
import { reducer } from './reducer'
import * as actions from './actions'

// Dispatch
export type DispatchType = Dispatch<ActionType<typeof actions>>
export const DispatchContext = createContext<DispatchType>(() => {})

// State
export type QuestionnaireState = StateType<typeof reducer>
export const StateContext = createContext<QuestionnaireState>({})
